export const UNIT_MS_CONVERSIONS = {
  second: 1000,
  minute: 60000,
  hour: 3600000,
  day: 86400000
};
